import { render } from "./AdminLogsComponent.vue?vue&type=template&id=ef403a3c&scoped=true"
import script from "./AdminLogsComponent.vue?vue&type=script&lang=js"
export * from "./AdminLogsComponent.vue?vue&type=script&lang=js"

import "./AdminLogsComponent.vue?vue&type=style&index=0&id=ef403a3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef403a3c"]])

export default __exports__